export default {
    ALL: 'ALL',
    DISPUTED: 'DISPUTED',
} as const;
